import { CONFIG_TYPE } from "../constants/configTypes";
import { IAM_STATUSES } from "../constants/iamStatuses";

export interface ClientForm {
  name: string;
  bdmId: number | null;
  configType: CONFIG_TYPE;
  dealRecipientClientId: number | null;
  aggregatorName?: string;
  aggregatorNameOther?: string;
  status: string;
}

export const clientFormDefaultValue: ClientForm = {
  name: "",
  bdmId: null,
  configType: CONFIG_TYPE.EXTERNAL_BROKERAGE,
  dealRecipientClientId: null,
  aggregatorName: "",
  aggregatorNameOther: "",
  status: IAM_STATUSES.ACTIVE,
};
